import { Grid, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";

function MarketPrices({ coinMarketDetails }) {
  return (
    <Grid container>
      <Grid item xs={6} textAlign="right">
        <Typography variant="h3" color="success.main">
          <Typography variant="subtitle2" color="text.main">
            Buy
          </Typography>

          <NumberFormats value={coinMarketDetails?.priceBuy} />
        </Typography>
      </Grid>

      <Grid item xs={6} textAlign="right">
        <Typography variant="h3" color="error.main">
          <Typography variant="subtitle2" color="text.main">
            Sell
          </Typography>

          <NumberFormats value={coinMarketDetails?.priceSell} />
        </Typography>
      </Grid>
    </Grid>
  );
}

export default MarketPrices;
